import { useMutation, useQueryClient } from 'react-query';
import { useWarningToast } from '../../hooks/useWarningToast';
import {
  retryChargeAutoTopUp,
  type RetryChargeAutoTopUpResponse
} from '@pocapan/shared/domains/bettie/services/bettieAutoTopUpService';

export function useRetryChargeAutoTopUp() {
  const queryClient = useQueryClient();
  const showWarningToast = useWarningToast();
  return useMutation<RetryChargeAutoTopUpResponse, Error, string>(
    (bettieAutoTopUpId: string) => retryChargeAutoTopUp(bettieAutoTopUpId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bettieAutoTopUp']);
      },
      onError: (error) => {
        showWarningToast(
          'bottom',
          (error as { error?: { message?: string } })?.error?.message as string
        );
      }
    }
  );
}
